"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/toggle.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Toggle = function Toggle(_ref) {
  var id = _ref.id,
      state = _ref.state,
      onChange = _ref.onChange,
      disabled = _ref.disabled,
      labelLeft = _ref.labelLeft,
      labelRight = _ref.labelRight,
      className = _ref.className;

  var toggleClasses = _defineProperty({}, "label-disabled", disabled);

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "".concat(className, " toggleContainer")
  }, labelLeft && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("span ".concat(state ? 'label-false' : 'label-true'), toggleClasses)
  }, labelLeft), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: "toggle-".concat(id),
    className: "switch" // className={classNames(toggleClasses)}

  }, /*#__PURE__*/_react.default.createElement("input", {
    type: "checkbox",
    id: "toggle-".concat(id),
    disabled: disabled,
    checked: state,
    onChange: onChange
  }), /*#__PURE__*/_react.default.createElement("span", {
    className: "slider"
  })), labelRight && /*#__PURE__*/_react.default.createElement("span", {
    className: (0, _classnames.default)("span ".concat(state ? 'label-true' : 'label-false'), toggleClasses)
  }, labelRight));
};

Toggle.propTypes = {
  id: _propTypes.default.string,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  state: _propTypes.default.bool,
  onChange: _propTypes.default.func
};
Toggle.defaultProps = {
  className: '',
  disabled: false,
  state: false,
  onChange: null
};
var _default = Toggle;
exports.default = _default;